import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import * as RegionsActions from '../actions/region.actions';
import {catchError, exhaustMap, switchMap, withLatestFrom} from 'rxjs/operators';
import {of} from 'rxjs';
import {RegionsService} from '../../../core/services/regions.service';
import * as Reducers from '../reducers';
import { Store } from '@ngrx/store';

@Injectable()
export class RegionsEffects {

  getRegions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RegionsActions.getRegions.type),
      withLatestFrom(
        this.store$.select(Reducers.getRegions)
      ),
      switchMap(([action, regions]) => {
          if (regions) {
            return of(RegionsActions.getRegionsSuccess({regions: regions}));
          } else {
            return this.regionsService.getRegions()
              .pipe(
                exhaustMap((data) => of(RegionsActions.getRegionsSuccess({regions: data}))),
                catchError(error => of(RegionsActions.getRegionsFailure({error})))
              )
          }
        }
      )
    )
  );

  constructor(
    private actions$: Actions,
    private store$: Store<any>,
    private regionsService: RegionsService
  ) { }
}
